import React from 'react'
import { jt, t } from 'ttag'
import CopyToClipboard from 'react-copy-to-clipboard'
import { connect } from 'react-redux'

import { getTenantInfo } from '../../actions/educator'

class LinkGenerator extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      copied: false,
      width: '400',
      height: '100',
      sizeValue: '1',
      textValue: '1'
    }
  }

  componentDidMount() {
    this.props.dispatch(getTenantInfo())
  }

  setWidth(w, baseThis) {
    baseThis.setState({
      ...baseThis.state,
      width: w
    })
  }

  setHeight(h, baseThis) {
    baseThis.setState({
      ...baseThis.state,
      height: h
    })
  }

  setSize(v, baseThis) {
    console.log(v, new String(v))
    const st = {
      ...baseThis.state,
      sizeValue: v
    }

    switch (v) {
      case '2':
        st.width = '250'
        st.height = '75'
        break
      case '1':
        st.width = '350'
        st.height = '175'
        break
    }

    baseThis.setState(st)
  }

  setText(v, baseThis) {
    baseThis.setState({
      ...baseThis.state,
      textValue: v
    })
  }

  render() {
    const baseThis = this
    const cWidth = this.state.textValue === '1' ? 3 : 1
    const careerText = t`A Career Readiness Platform made for you:`
    const htmlToCopy = `<div style="width: ${this.state.width}px"><a href="${
      this.props.educatorPortal?.url
    }">${
      this.state.textValue === '1'
        ? `<span style="display: inline-block; vertical-align: middle; width: ${Math.floor(
            2 * (this.state.width / cWidth)
          )}px">${careerText}</span>`
        : ''
    }<img src="${
      this.props.educatorPortal?.logo
    }"  style="vertical-align: middle; margin-right: 10px; max-width: ${Math.floor(
      this.state.width / cWidth
    )}px; max-height: ${this.state.height}px" /></a></div>`
    const outputHtml = (
      <div className="output-preview-container">
        <a href={this.props.educatorPortal?.url}>
          {this.state.textValue === '1' ? (
            <span
              style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                width: `${2 * (this.state.width / cWidth)}px`
              }}>
              {careerText}
            </span>
          ) : (
            <span></span>
          )}
          <img
            src={this.props.educatorPortal?.logo}
            style={{
              verticalAlign: 'middle',
              maxWidth: '100%',
              width: `${this.state.width / cWidth}px`,
              maxHeight: `${this.state.height}px`
            }}
          />
        </a>
      </div>
    )

    return (
      <div>
        <div className="link-generator container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <h3 className="section-heading">{jt`Link to ${dynamicValues.systemName} directly from your School, District, Library, or Organization's Home Page`}</h3>
              <p className="subtext">
                {' '}
                {t`Want to add a link to us on your website? Use the code generator below to create HTML that can be copied directly into your website.`}
              </p>
              <div className="col-sm-6">
                <div>{t`Choose a size:`}</div>
                <div className="size-option">
                  <label>
                    <input
                      type="radio"
                      value="1"
                      name="size"
                      onChange={v => this.setSize(v.target.value, baseThis)}
                      checked={this.state.sizeValue === '1'}
                    />
                    &#160;{t`Large`}
                  </label>
                </div>
                <div className="size-option">
                  <label>
                    <input
                      type="radio"
                      value="2"
                      onChange={v => this.setSize(v.target.value, baseThis)}
                      name="size"
                      checked={this.state.sizeValue === '2'}
                    />
                    &#160;{t`Small`}
                  </label>
                </div>
                <div className="size-option">
                  <label>
                    <input
                      type="radio"
                      value="3"
                      onChange={v => this.setSize(v.target.value, baseThis)}
                      name="size"
                      checked={this.state.sizeValue === '3'}
                    />
                    &#160;{t`Custom`}
                  </label>
                  :&#160;&#160;&#160;{' '}
                  <input
                    type="text"
                    size="4"
                    onFocus={v => this.setSize('3', baseThis)}
                    onChange={v => this.setWidth(v.target.value, baseThis)}
                    value={this.state.width}
                  />
                  w x{' '}
                  <input
                    type="text"
                    size="4"
                    onFocus={() => v => this.setSize('3', baseThis)}
                    onChange={v => this.setHeight(v.target.value, baseThis)}
                    value={this.state.height}
                  />
                  h
                </div>
              </div>
              <div className="col-sm-6">
                <div>{t`Choose a presentation:`}</div>
                <div className="text-option">
                  <label>
                    <input
                      type="radio"
                      value="1"
                      name="text"
                      onChange={v => this.setText(v.target.value, baseThis)}
                      checked={this.state.textValue === '1'}
                    />
                    &#160;{t`With Text`}
                  </label>
                </div>
                <div className="text-option">
                  <label>
                    <input
                      type="radio"
                      value="2"
                      name="text"
                      onChange={v => this.setText(v.target.value, baseThis)}
                      checked={this.state.textValue === '2'}
                    />
                    &#160;{t`Graphic Only`}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row with-border" style={{ marginTop: '25px' }}>
            <div className="col-xs-6">
              <div style={{ marginTop: '15px' }}>{t`Output`}</div>
              {outputHtml}
            </div>
            <div className="col-xs-6">
              <div style={{ marginTop: '15px' }}>{t`HTML Code Snippet`}</div>
              <textarea
                style={{
                  height: '230px',
                  width: '100%',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                  padding: '5px'
                }}
                value={htmlToCopy}
                readOnly={true}>
              </textarea>
              <br />
              <CopyToClipboard
                text={htmlToCopy}
                onCopy={() => this.setState({ ...this.state, copied: true })}>
                <button className="btn btn-default pull-right no-style">
                  <i className="copy"></i> {t`Copy to clipboard`}{' '}
                  {this.state.copied && <i className="fal fa-check"></i>}
                </button>
              </CopyToClipboard>
            </div>
            <br className="clear" />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      dynamicValues
    }
  },
  dispatch => ({
    dispatch
  })
)(LinkGenerator)
